import { useState, useCallback } from 'react';

export const useMapVisibility = () => {
  const [showMap, setShowMap] = useState(false);

  const toggleMapVisibility = useCallback(() => {
    setShowMap(prev => !prev);
  }, []);

  return {
    showMap,
    toggleMapVisibility,
  };
};